<div [formGroup]="form">
    <mat-form-field style="width:100%;">
        <mat-label *ngIf="show">{{label}}</mat-label>
        <textarea matInput [formControlName]="name" [placeholder]="label" #input></textarea>
        <mat-error *ngIf="form && form.get(name).hasError('required')">
            {{label}} is <strong>required</strong>
        </mat-error>
    </mat-form-field>
</div>
